import styled from "styled-components"

import { SPACING } from "../../component-library/design/spacing/spacing.constants"

const CalendarContainer = styled.div`
  margin-right: ${SPACING.S};
`

export { CalendarContainer }
